import { z } from "zod";

const cguDocumentUrlSchema = z.union([
  z.string().url(),
  z.string().regex(/^\/.+/, "Chemin relatif attendu (ex. /api/cgu/document)"),
]);

/** Réponse `GET /api/cgu` — URLs et version alignées sur le serveur. */
export const cguConfigSchema = z.object({
  requiredVersion: z.string(),
  documentUrl: cguDocumentUrlSchema,
  charteIaUrl: z.string().url(),
});

export type CguConfig = z.infer<typeof cguConfigSchema>;
